import ResponsiveCDNImage from "../../../../components/common/image/responsive-cdn-image";

interface ReviewListHeaderProps {
  storeImg?: string | null;
  storeTitle?: string | null;
}

export function ReviewListHeader({
  storeImg,
  storeTitle,
}: ReviewListHeaderProps) {
  return (
    <div className="w-full h-full pb-2">
      <div className="relative">
        <ResponsiveCDNImage
          src={storeImg || ""}
          alt="매장 이미지"
          className="w-[100%] aspect-video object-cover "
        />
        <p className="absolute bottom-0 text-white text-2xl font-bold left-0 right-0 p-4 bg-gradient-to-t from-black/90 to-transparent">
          {storeTitle}
        </p>
      </div>
    </div>
  );
}
